import type {
  GQLLocale,
  MutationAssociateWithThirdPartyProviderArgs,
  MutationLoginWithThirdPartyProviderArgs,
  ThirdPartyProvider,
} from 'graphql-ts-types';
import { LoginFlow } from 'graphql-ts-types';

import { executeQuery } from 'common/gql';
import associateThirdPartyProviderMutation from '../../../gql/mutation/associate-account.gql';
import performLoginMutation from '../../../gql/mutation/third-party-login.gql';
import type { ThirdPartyAssociationResponse, ThirdPartyLoginResponse } from '../../../gql/types';

interface ThirdPartyLoginParams {
  locale: GQLLocale;
  provider: ThirdPartyProvider;
  providerToken: string;
}

interface ThirdPartyAssociationParams {
  provider: ThirdPartyProvider;
  providerToken: string;
}

export const executeThirdPartyLoginQuery = ({
  locale,
  provider,
  providerToken,
}: ThirdPartyLoginParams) =>
  executeQuery<ThirdPartyLoginResponse, MutationLoginWithThirdPartyProviderArgs>({
    query: performLoginMutation,
    variables: {
      locale,
      provider,
      provider_token: providerToken,
      flow: LoginFlow.WebsiteSession,
    },
  });

export const executeThirdPartyAssociationQuery = ({
  provider,
  providerToken,
}: ThirdPartyAssociationParams) =>
  executeQuery<ThirdPartyAssociationResponse, MutationAssociateWithThirdPartyProviderArgs>({
    query: associateThirdPartyProviderMutation,
    variables: {
      provider,
      provider_token: providerToken,
    },
  });
